import { render, staticRenderFns } from "./DevelopmentSection.vue?vue&type=template&id=c598c226&scoped=true&"
import script from "./DevelopmentSection.vue?vue&type=script&lang=js&"
export * from "./DevelopmentSection.vue?vue&type=script&lang=js&"
import style0 from "./DevelopmentSection.vue?vue&type=style&index=0&id=c598c226&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c598c226",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/var/www/nmg-charitychallenge.com/charity-challenge/frontbuild/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
installComponents(component, {VContainer})
